import { DAG } from '@pollination-solutions/pollination-sdk'

export const parentDagByTaskName = (recipe: DAG[], name: string): DAG | undefined => {
  let parent: DAG | undefined = undefined

  recipe.forEach((dag) => {
    if (parent) {
      return
    }

    dag.tasks.forEach((task) => {
      if (task.name === name) {
        parent = dag
      }
    })
  })

  return parent
}
